import { atom } from "jotai";
import { nodesAtom } from "../nodes";
import { DefaultNodeData } from "../types";

export const isBlankCanvasAtom = atom((get) => {
  const nodes = get(nodesAtom);

  // Truly empty canvas is always blank
  if (nodes.length === 0) return true;

  // Canvas with multiple nodes is not blank
  if (nodes.length !== 1) return false;

  // Check if the single node is a default node without an asset attached
  const node = nodes[0];
  if (node.type !== "default") return false;

  const defaultData = node.data as DefaultNodeData;

  // Consider blank if it's a default node with no asset attached
  // (no tableId, projectId, pageId, chatbotId, agentId, etc.)
  const hasAssetAttached = !!(
    defaultData.tableId ||
    defaultData.projectId ||
    defaultData.pageId ||
    defaultData.chatbotId ||
    defaultData.agentId
  );

  return !hasAssetAttached;
});
isBlankCanvasAtom.debugLabel = "isBlankCanvasAtom";
